type EmbedProps = {
  attrs: {
    href: string;
  };
};

export const NativeVideo = (props: EmbedProps): string | null => {
  const { href } = props.attrs;

  return `<video
      controls
      width="100%"
      height="auto"
      src="${href}"
      title="Native Video"
      style="border-radius: 8px; overflow: hidden;"
      controlslist="nodownload"
      playsinline
    >
      Your browser does not support the video tag.
    </video>`;
};

// Static method to check if the href matches a native video URL
NativeVideo.isMatch = (href: string): boolean => {
  const [url] = href.split('?');
  const videoExtensions =
    /\.(mp4|webm|ogg|mov|m4v|avi|flv|wmv|mkv)(?:\?.*|#.*)?$/i;

  if (url && videoExtensions.test(url)) {
    return true;
  }

  return false;
};
